import { Stage, Layer, Rect, Circle, Text } from 'react-konva';
import React, { useState, useEffect, useRef } from 'react';
import { useSocketEvent } from '../../helpers/useSocket';
import useImage from 'use-image';
import classNames from 'classnames';




export function LiveGameMinimap({ width, height }) {

    const [minimapData, setMinimapData] = useState([]);
    const [whiteSheepIcon] = useImage('/minimap/sheep.webp');
    const [blackSheepIcon] = useImage('/minimap/black_sheep.webp');
    const [brownSheepIcon] = useImage('/minimap/brown_sheep.webp');
    const [pinkSheepIcon] = useImage('/minimap/pink_sheep.webp');
    const [showState, setShowState] = useState(false)

    const [shadowBlur, setShadowBlur] = useState(0);
    const frameRef = useRef(0);
    const startRef = useRef(0);

    function getSheepIcon(pbgid) {
        console.log(pbgid)
        let sheepIcon = whiteSheepIcon
        if (pbgid === 9004501) {
            sheepIcon = blackSheepIcon
        }
        if (pbgid === 9004502) {
            sheepIcon = brownSheepIcon
        }
        if (pbgid === 9004503) {
            sheepIcon = pinkSheepIcon
        }
        console.log(sheepIcon)
        return sheepIcon
    }

    useSocketEvent('updateMinimapData', (newdata) => {
        console.log(`Received updateConfig`, newdata);
        setMinimapData(newdata)
    })

    useSocketEvent(`toggleMinimap`, (newData) => {
        console.log("toggled minimap")
        setShowState(newData)
    })

    //Made by ChatGPT 5.0
    //Need to rotate the map 135 degrees, since there is some weird conversion but I CBA looking into it
    function convertAtoB(xA, yA) {
        const rangeA = 407;  // from -203.5 to +203.5
        const rangeB = 242;  // size of system B

        // Normalize A’s coordinates to [0, 1]
        const normX = (xA + 203.5) / rangeA;
        const normY = (yA + 203.5) / rangeA;

        // Scale to B
        const scaledX = normX * rangeB;
        const scaledY = normY * rangeB;

        // Flip horizontally to account for top-right origin in B
        const xB = rangeB - scaledX;
        const yB = scaledY;

        return { xB, yB };
    }

    useEffect(() => {
        const min = 10;
        const max = 20;
        const duration = 3000;

        const amplitude = (max - min) / 2;
        const center = min + amplitude;

        const animate = (timestamp) => {
            if (!startRef.current) {
                startRef.current = timestamp;
            }

            const elapsed = timestamp - startRef.current;
            const t = (elapsed % duration) / duration;

            const sine = Math.sin(t * 2 * Math.PI);
            const blur = center + amplitude * sine;

            setShadowBlur(blur);

            frameRef.current = requestAnimationFrame(animate);
        };

        frameRef.current = requestAnimationFrame(animate);

        return () => {
            cancelAnimationFrame(frameRef.current);
        };
    }, []);

    return (
        <Stage className={classNames('liveGameOverlay__minimap', showState && 'liveGameOverlay__minimapShow')} width={width} height={height}
            style={{
                border: 'solid', borderWidth: '1px', width: width, borderColor: "transparent"

            }}>
            <Layer>
                {pinkSheepIcon && minimapData?.neutralSheepPositions?.map((sheep, i) => {
                    let sheepIcon = getSheepIcon(sheep.pbg_id)
                    return (
                        <Circle key={"sheep" + i}

                            x={convertAtoB(sheep.position.x, sheep.position.z).xB - 15}
                            y={convertAtoB(sheep.position.x, sheep.position.z).yB + 15}
                            radius={40}
                            fillPatternImage={sheepIcon}
                            fillPatternRepeat={"no-repeat"}
                            fillPatternOffsetX={1}
                            fillPatternOffsetY={1}

                            fillPatternScaleX={0.03}
                            fillPatternScaleY={0.03}

                            fillPatternRotation={-135}

                            shadowColor="#e784a3"
                            shadowBlur={sheep.pbg_id === 9004503 ? shadowBlur : null}
                            shadowOpacity={0.9}
                            shadowOffset={{ x: 0, y: 0 }} // centered glow
                        />
                    )
                }
                )}
            </Layer>
        </Stage>
    );
}